import React from 'react';
import FeederSummary from './FeederSummary';
import FeederDetails from './FeederDetails';
import { RecalcModal, ScoreDetailModal } from '../../../../FeederScore/CloudFeederScorePanel';

/**
 * Renderiza el bloque FeederScoreView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function FeederScoreView({
  v
}) {
  return v.viewFs ? React.createElement(React.Fragment, null, v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": "minmax(0,1fr) 17.708333vw",
      "gap": "1.111111vh"
    }
  }, v.text("\n    "), React.createElement(FeederSummary, {
    v
  }), v.text("\n    "), React.createElement(FeederDetails, {
    v
  }), v.text("\n  ")), React.createElement(RecalcModal, {
    open: Boolean(v.fsRecalcOpen),
    onClose: v.fsRecalcClose,
    activeParams: v.fsRecalcParams,
    defaults: v.fsRecalcDefaults,
    level: v.fsRecalcLevel,
    groupMode: v.fsRecalcGroup,
    t: (_key, fallback) => fallback,
    onApply: v.fsRecalcApply,
    onOriginal: v.fsRecalcOriginal,
    onReset: v.fsRecalcReset
  }), React.createElement(ScoreDetailModal, {
    open: Boolean(v.fsDetailOpen),
    onClose: v.fsCloseDetail,
    data: v.fsDetailData,
    day: v.fsDetailDay,
    t: (_key, fallback) => fallback,
    variant: "v2"
  }), v.text("\n  ")) : null;
}
